import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto max-w-screen-2xl" }
const _hoisted_2 = { class: "justify-between space-y-3 pb-6 sm:flex sm:space-x-3 sm:space-y-0" }
const _hoisted_3 = { class: "w-full sm:w-auto" }
const _hoisted_4 = { class: "rounded-3xl bg-sky-blue-200 p-6" }
const _hoisted_5 = {
  key: 2,
  class: "block h-8"
}
const _hoisted_6 = {
  key: 3,
  class: "mt-10 w-full text-center"
}

import { onMounted, computed, watch, nextTick } from "vue";
import { storeToRefs } from "pinia";

import { getTranslation } from "~/js/composables/translations";

import { animateOverviewGridItems } from "~/js/utils/animation";

import { Translations } from "~/js/interfaces/translations";
import { Facet, FacetCount } from "~/js/interfaces/facets";

import { useBlogStore } from "~/js/store/blog";

import Grid from "~/vue/organisms/grids/GridLandings.vue";
import GridSkeleton from "~/vue/organisms/grids/GridSkeleton.vue";
import ButtonLoadMore from "~/vue/atoms/buttons/ButtonLoadMore.vue";
import TextH3 from "~/vue/atoms/texts/TextH3.vue";
import TextBody from "~/vue/atoms/texts/TextBody.vue";
import FilterMultiselect from "~/vue/molecules/filters/FilterMultiselect.vue";
import SvgLoader from "~/vue/atoms/svgs/SvgLoader.vue";
import HeaderGrids from "~/vue/molecules/headers/HeaderGrids.vue";

interface Props {
	translations?: Translations | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewBlog',
  props: {
    translations: { default: null }
  },
  setup(__props: any) {

const props = __props;
const blogStore = useBlogStore();
const { blogs, loading, pagination, facets, filters } = storeToRefs(blogStore);

const onFetch = () => {
	blogStore.fetch();
};

const onLoadMore = () => {
	blogStore.fetch(false);
};

const yearFilter = computed(() => {
	let filteredFacet = facets.value?.find((facet: Facet) => facet.field_name === "postDateYear");
	// const currentYear =  new Date().getFullYear()

	// if (filteredFacet) {
	//     filteredFacet.counts.forEach((count: FacetCount) => {
	//         if (count.value == currentYear) {
	//             count.value = `${getTranslation(props.translations,'Most recent')} (${new Date().getFullYear()})`
	//         }
	//     })
	// }

	return filteredFacet;
});

const updateFacet = (facet) => {
	blogStore.setFilter(facet.field, facet.value);
};

watch(blogs, () => {
	if (blogs.value && blogs.value.length > 0) {
		nextTick(() => {
			animateOverviewGridItems();
		});
	}
});

onMounted(async () => {
	await onFetch();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HeaderGrids, {
          heading: _unref(getTranslation)(__props.translations, 'Blog posts'),
          results: !_unref(loading) ? _unref(pagination).foundResults : null
        }, null, 8, ["heading", "results"]),
        _createElementVNode("div", _hoisted_3, [
          (yearFilter.value)
            ? (_openBlock(), _createBlock(FilterMultiselect, {
                key: 0,
                label: _unref(getTranslation)(props.translations, 'Select a year'),
                type: "date",
                facet: yearFilter.value,
                loading: _unref(loading),
                translations: __props.translations,
                selected: _unref(filters).date.values,
                "dropdown-position": "right",
                utilities: "mt-4 md:mt-0",
                onSetFacet: _cache[0] || (_cache[0] = ($event: any) => (updateFacet($event)))
              }, null, 8, ["label", "facet", "loading", "translations", "selected"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_unref(blogs))
          ? (_openBlock(), _createBlock(Grid, {
              key: 0,
              animate: true,
              items: _unref(blogs).map((blog) => blog.document)
            }, null, 8, ["items"]))
          : _createCommentVNode("", true),
        (_unref(loading) && !_unref(blogs))
          ? (_openBlock(), _createBlock(GridSkeleton, {
              key: 1,
              size: _unref(pagination).itemsPerPage
            }, null, 8, ["size"]))
          : _createCommentVNode("", true),
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_5))
          : _createCommentVNode("", true),
        (_unref(pagination).current < _unref(pagination).totalPages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(pagination).current < _unref(pagination).totalPages)
                ? (_openBlock(), _createBlock(ButtonLoadMore, {
                    key: 0,
                    title: _unref(getTranslation)(__props.translations, 'Load more blog posts'),
                    loading: _unref(loading),
                    ga: {
							category: 'blog-load-more',
							action: 'click',
							label: _unref(pagination).current,
						},
                    utilities: "mx-auto",
                    onClick: onLoadMore
                  }, null, 8, ["title", "loading", "ga"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})